import React from 'react'
import WORDING from 'constants/wording'
import { tableItemButton } from 'constants/tableItem'
import BtnTableItem from '../assets/images/BtnTableItem.svg'

// TODO: mapear el uso de este componente y tratar de generar
// uno nuevo. Utilizando un átomo Card y separando mejor los usos
// entre item de una lista, botón, etc.

export default function TableItem({
  label = '',
  value = '',
  subtitle = '',
  description = null,
  buttonType = null,
  onClick = () => null,
  className = '',
  valueClassName = ''
}) {
  const formattedDescription = shortener(description)

  function getButtonByType() {
    switch (buttonType) {
      case tableItemButton.COPY:
        return (
          <button
            type='button'
            onClick={onClick}
            className='text-purple-900 text-xs font-bold hover:opacity-70'
          >
            {WORDING.COPIAR}
          </button>
        )
      case tableItemButton.ARROW:
        return (
          <>
            {/* eslint-disable-next-line */}
            <button
              data-testid='tableItemButton'
              type='button'
              onClick={onClick}
            >
              <img className='hover:opacity-70' src={BtnTableItem} alt='' />
            </button>
          </>
        )
      default:
        break
    }
  }

  function shortener(inputValue) {
    if (!inputValue) return
    const normalized = String(inputValue)
    if (!/\s/.test(normalized) && normalized.length > 22) {
      return `${normalized.slice(0, 20)}...`
    }
    return inputValue
  }

  return (
    <li
      data-testid='listItem'
      className={`flex items-center justify-between font-medium py-4 text-xs border-b border-solid border-gray-500 last:border-0 leading-[140%] ${className}`}
    >
      <div
        className={`flex-grow text-purple-900 font-medium max-w-[90%] ${
          subtitle ? 'flex-col' : ''
        } flex`}
      >
        {label && <span className='pr-1'>{label}: </span>}
        <span className={`font-bold text-base ${valueClassName}`}>{value}</span>
        <span className='text-gray-900 text-xs font-medium font-manrope'>
          {subtitle}
        </span>

        <p>{formattedDescription}</p>
      </div>
      {buttonType && getButtonByType()}
    </li>
  )
}
